import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { about, allInOne, barkodOxuyucu, barkodPrinter, barkodProcessor, cardReader, carousel2, dataTerminal, hero, pulQutulari, rightUp } from '../../../assets/index';
import { useTranslation } from 'react-i18next';


const About = () => {

  const { t, i18n } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);
  return (
   <div className='bg-[black] md:rounded-t-[40px]'>
    <div className='max-w-containerSm md:max-w-container mx-auto mt-[44px] md:mt-[80px] text-white py-[80px]'>
    <p className='text-[24px] md:text-[40px] font-bold md:font-semibold font-barlow text-center mb-12'>Rahatlıq və Səmərəliliyin Birləşdiyi <span className='font-barlow text-[#E11E26]'>Mərkəz</span></p>
    <div className='md:flex gap-8'>
        <div className='md:w-[505px]'>
        <img className='rounded-[20px]' src={about}></img>
        </div>
        <div className='md:w-[657px] flex flex-col justify-center mt-5 md:mt-0'>
            <p className='md:mb-6 mb-4 text-[18px] md:text-[20px]'>İş Dünyasında Fərq Yaradan Məkan; AF HOLDINQ</p>
            <p className='md:mb-16 mb-9 text-[14px]'>İş mərkəzimiz müasir ofis sahələri, premium xidmətlər və geniş imkanlarla fərq yaradır. Burada sizə rahatlıq, prestij və səmərəliliyi bir arada təqdim edirik. Gözəllik salonu, fitness mərkəzi, hovuz və geniş parking kimi xidmətlərlə işinizə tam fokuslanma imkanı əldə edirsiniz. Biznesinizin hər addımında uğurunuza dəstək olmaq üçün ən ideal şəraiti təmin edirik. Burada fərqi hiss edin, iş dünyasında bir addım öndə olun.</p>
           <a href='/about'> <button className=' text-[white] rounded-[8px] hover:bg-[#898989] hover:border-[#898989] w-[148px] border-[2px] border-[#898989] h-[40px] flex items-center justify-center'>
  Daha çox
</button></a>

        </div>
    </div>
   </div>
   </div>
  );
}; 
 
export default About; 